import { MessagesSet, MessageMsgFrom, MessageMsgType } from '@tencent/dz-models';
import { HistoryMessage } from '../interface';
import { jsonParseSandbox } from './jsonParseSandbox';
import { removeWidthAndHeightFromRichTextImage } from './removeWIdthAndHeightFromRichTextImage';

export const formatMessageEntities = (entities: HistoryMessage['entities']): MessagesSet[] => entities.map((entitie) => {
  const msgCotnent = jsonParseSandbox(entitie.msg_content);

  let message = entitie.msg_content;
  if (entitie.msg_type === 15) {
    // 对一键电话号码进行消息处理
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const { leave_msg_content = {} } = msgCotnent;
    const phone = leave_msg_content.customer_phone || leave_msg_content.encrypt_phone;
    message = `我的联系方式：${phone}`;
  } else if (entitie.msg_from === MessageMsgFrom.Server && entitie.msg_type === MessageMsgType.Rich) {
    message = removeWidthAndHeightFromRichTextImage(message);
  }
  // eslint-disable-next-line no-nested-ternary
  const type = entitie.msg_from === 0 ? 2 : entitie.msg_from === 1 || entitie.msg_from === 4 ? 1 : 3;
  return {
    type,
    msg_type: entitie.msg_type,
    msg_from: type,
    msg_is_new: false,
    payload: {
      message: msgCotnent.question ? msgCotnent.question : message,
      answers: msgCotnent.question ? msgCotnent.answers : undefined,
      disabled: !!msgCotnent.question,
    },
  };
});
